import {ComponentType} from 'react';

export const defaultExport = (namedExport: string) => (exportObject: {[key: string]: ComponentType<any>}) => ({
    default: exportObject[namedExport],
});
